module.exports = __webpack_public_path__ + "static/img/6.c2ad647e.jpg";